import request from './index';
import type {
  IPlatformCompaniesResponse,
  IPlatformCompanyPayload,
  IPlatformCompanyResponse
} from 'types/platformCompany';

export const getPlatformCompanies = () =>
  request<IPlatformCompaniesResponse>({
    options: {
      url: '/platform/admin/companies',
      method: 'get'
    }
  });

export const createPlatformCompany = (payload: IPlatformCompanyPayload) =>
  request<IPlatformCompanyResponse>({
    options: {
      url: '/platform/admin/companies',
      method: 'post',
      data: payload
    }
  });
